import { sendMessage } from "../common/postMassages"

export const postSelectOdd = (oddId: number) => {
    sendMessage('SELECT_ODD', oddId.toString())
}

export const postSelectFavorite = (gameId: number) => {
    sendMessage('SELECT_FAVORITE', gameId.toString())
}

export const postSelectSportType = (sportTypeId: number) => {
    sendMessage('SELECT_SPORT_TYPE', sportTypeId.toString())
}

export const postFilterLiveStreams = () => {
    sendMessage('FILTER_LIVE_STREAMS','')
}

export const postOpenLiveGame = (gameId: number, sportTypeId: number) => {
    sendMessage('OPEN_LIVE_GAME', { gameId: gameId.toString(), sportTypeId: sportTypeId.toString() })
}

export const postShowSuspendedPositionErrorMessage = () => {
    sendMessage('SHOW_SUSPENDED_POSITION_MESSAGE', '')
}

export const postOpenSportBonusPromo = () => {
    sendMessage('OPEN_SPORT_BONUS_PROMO', '')
}
